import { IFieldLangMap } from '@pharmsnap/shared/types'

export const NEWS_LANG_MAP: IFieldLangMap = {
  CN: {
    cn: '中文',
    en: 'CN',
    jp: '中国',
  },
  EN: {
    cn: '英文',
    en: 'EN',
    jp: '英語',
  },
}

export const NEWS_SECTION_LANG_MAP: IFieldLangMap = {
  0: {
    cn: '精选新闻',
    en: 'Featured News',
    jp: '注目ニュース',
  },
  1: {
    cn: '全球快讯',
    en: 'Global Express',
    jp: 'グローバル速報',
  },
}
